module.exports = __webpack_public_path__ + "static/media/ALO.81cfbaee.png";